"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PARTNER_PURCHASE_INVITE_UNAVAILABLE = exports.PARTNER_PURCHASE_INVITE_QUERY_PARAM = void 0;
exports.PARTNER_PURCHASE_INVITE_QUERY_PARAM = 'purchaseInvite';
exports.PARTNER_PURCHASE_INVITE_UNAVAILABLE = 'PARTNER_PURCHASE_INVITE_UNAVAILABLE';
